import React from 'react';
import { Phone, Mail, Instagram, MapPin, ArrowUpRight } from 'lucide-react';
import { contactData } from '../../data/mock';

const LOGO_URL = "/LOGO-CREDJURIS.svg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'O Problema', href: '#problema' },
    { label: 'Soluções', href: '#solucoes' },
    { label: 'Diagnóstico', href: '#diagnostico' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <a href="#" className="inline-block mb-6">
              <img
                src={LOGO_URL}
                alt="Credjuris"
                className="h-12 w-auto brightness-0 invert"
              />
            </a>

            <p className="text-slate-400 leading-relaxed mb-6 max-w-md">
              Escritório especializado em soluções jurídicas e financeiras para regularização de dados de crédito.
            </p>

            {/* Disclaimer */}
            <div className="p-4 bg-slate-800/50 border border-slate-700 rounded-xl">
              <p className="text-sm text-slate-400 leading-relaxed">
                <span className="text-amber-400 font-semibold">Aviso Legal:</span> {contactData.disclaimer}
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Navegação</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors duration-200 flex items-center gap-1 group"
                  >
                    <span>{link.label}</span>
                    <ArrowUpRight className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contato</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={contactData.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-slate-400 hover:text-emerald-400 transition-colors duration-200"
                >
                  <div className="w-10 h-10 bg-emerald-600/20 rounded-lg flex items-center justify-center">
                    <Phone className="w-5 h-5 text-emerald-400" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">WhatsApp</p>
                    <p className="font-medium text-white">{contactData.whatsapp}</p>
                  </div>
                </a>
              </li>

              <li>
                <a
                  href={`mailto:${contactData.email}`}
                  className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors duration-200"
                >
                  <div className="w-10 h-10 bg-amber-400/20 rounded-lg flex items-center justify-center">
                    <Mail className="w-5 h-5 text-amber-400" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Email</p>
                    <p className="font-medium text-white">{contactData.email}</p>
                  </div>
                </a>
              </li>

              <li>
                <a
                  href={contactData.instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-slate-400 hover:text-pink-400 transition-colors duration-200"
                >
                  <div className="w-10 h-10 bg-pink-500/20 rounded-lg flex items-center justify-center">
                    <Instagram className="w-5 h-5 text-pink-400" />
                  </div>
                  <div>
                    <p className="text-xs text-slate-500">Instagram</p>
                    <p className="font-medium text-white">{contactData.instagram}</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} Credjuris. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-1 text-slate-500 text-sm">
              <MapPin className="w-4 h-4" />
              <span>Mato Grosso, Brasil</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
